"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var keyDownHandler = {
  //keyboard Events -> key
  keys: {
    up: "arrowup",
    down: "arrowdown",
    left: "arrowleft",
    right: "arrowright",
    "delete": "delete",
    backspace: "backspace",
    spacebar: " ",
    enter: "enter",
    escape: "escape",
    tab: "tab",
    opensquarebracket: "[",
    closesquarebracket: "]"
  },
  //keyboard Events -> keyCode mapped to key
  keyCodes: function keyCodes(key) {
    var keyCode = {
      38: this.keys.up,
      40: this.keys.down,
      37: this.keys.left,
      39: this.keys.right,
      46: this.keys["delete"],
      8: this.keys.backspace,
      32: this.keys.spacebar,
      13: this.keys.enter,
      27: this.keys.escape,
      9: this.keys.tab,
      219: this.keys.opensquarebracket,
      221: this.keys.closesquarebracket
    };
    return keyCode[key];
  },
  getKeysFromEvent: function getKeysFromEvent(event) {
    if (event.key !== undefined && event.key !== "Unidentified") {
      return event.key.toLowerCase();
    } else if (event.keyCode !== undefined) {
      return this.keyCodes(event.keyCode);
    }
  }
};
var _default = exports["default"] = keyDownHandler;